import {CreditRepository} from './CreditRepository';
import {CreditDashboardAPIDataSource} from '../api/CreditDashboardAPIDataSource';
import {Store} from '../../stores/models/store.model';
import {StoreRepositoryImpl} from '../../stores/repository/StoreRepositoryImpl';
import {AppError} from '../../../Data/config/AppError';

export class CreditRepositoryImpl implements CreditRepository {
  private readonly creditDataSource: typeof CreditDashboardAPIDataSource;
  private readonly storeRepository: StoreRepositoryImpl;

  constructor () {
    this.creditDataSource = CreditDashboardAPIDataSource;
    this.storeRepository = new StoreRepositoryImpl();
  }

  async updateCreditLimit (
    storeId: number,
    payload: { credit_limit: number; reason?: string }
  ): Promise<Store> {
    try {
      // Call credit API to update credit limit
      await this.creditDataSource.updateCreditLimit(storeId, payload);

      // Refetch store details to get updated credit info
      const updatedStore = await this.storeRepository.getById(storeId.toString());
      return updatedStore;
    } catch (error) {
      throw AppError.fromApiError(error);
    }
  }
}
